import { Button } from '@mui/material';
import { Fragment, useState } from 'react';
import Confirm from './Confirm';

interface Props {
  title: string;
  color?: string;
  isTestMode?: boolean;
  handleTestMode: any;
}

function ConfirmButton({ title, color, isTestMode, handleTestMode }: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);

  return (
    <Fragment>
      <Button
        variant="contained"
        size="small"
        sx={{
          marginBottom: '5px',
          marginTop: '-10px',
          backgroundColor: isTestMode ? '#E63529' : 'primary.main',
          color: 'white',
          '&:hover': {
            backgroundColor: isTestMode ? 'darkred' : 'primary.dark',
          },
          '&.Mui-disabled': {
            backgroundColor: '#E63529',
            color: 'white',
          },
        }}
        onClick={onOpen}
        disabled={isTestMode}
      >
        {isTestMode ? 'TEST MODE IN PROGRESS' : 'TEST MODE'}
      </Button>

      <Confirm
        title={title}
        isOpen={isOpen}
        onClose={onClose}
        isTestMode={isTestMode}
        handleTestMode={handleTestMode}
      />
    </Fragment>
  );
}

export default ConfirmButton;
